var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import API_service from "@iscr/xAppLib/providers/API_service";
import { useAsync } from "@iscr/xAppLib/Hooks/useAsync";
// TODO Once we can use react query, update this use react query's caching mechanism to avoid multiple API calls
// from multiple mounted LoyaltyTierProviders
export const useOrgLoyaltyTier = ({ oid, year }) => {
    var _a;
    return useAsync({
        fn: () => __awaiter(void 0, void 0, void 0, function* () { return yield API_service.load_data(`loyalty/org/${oid}/year/${year}`); }),
        immediate: !!app.user.uid && !!oid,
    }, [
        oid,
        year,
        app.user.uid,
        // The loyalty program is controlled by `loyaltyEnabled` flag in this API response, but it is controlled
        // by site status. Rather than have the front-end know about the site status, we'll just use the flag here
        // to ensure we refetch, and the correct enabled status will propagate through. We don't care what the
        // site_status value _is_, we just want to refetch when it changes
        (_a = app.site_status) === null || _a === void 0 ? void 0 : _a.cosm_loyalty_enabled,
    ]);
};
